import styled, { css } from 'styled-components';

export const fieldTextCss = css`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
`;

export const FieldText = styled.span`
  display: inline-flex;
  align-items: center;
  min-width: 0;
  ${fieldTextCss};
`;
